import * as ActionTypes from './actionTypes'

export const  initializeValueBuildUpForm=(valueBuildUp)=>{


    return {
          type: ActionTypes.INITIALIZE_VALUE_BUILD_UP_FORM,
          payload:valueBuildUp,
      }
  
  
   }

export const updateInputFileds = (payload) =>{

  return{
    type:ActionTypes.UPDATE_INPUT_FILEDS,
    payload
   }

}

